/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import { useTranslation } from "react-i18next";

import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import { AppError } from "@ef/feature-app";

export interface ErrorScreenProps {
    readonly error: AppError | string;
    readonly resetError?: () => void
}

export default function ErrorScreen({ error, resetError}: ErrorScreenProps) {
    const { t } = useTranslation();
    
    return (
        <Container> 
            <Typography mt={4} variant="h4">
                {t("Unerwarteter Fehler")}
            </Typography>
            {typeof error === "string" ? [
                <Typography key="err_message" mt={2}>
                    {error}
                </Typography>
            ] : (
                error.title ? [
                    <Typography key="err_title" mt={2} variant="h5">
                        {error.title}
                    </Typography>,
                    <Typography key="err_message" mt={1}>
                        {error.message}
                    </Typography>
                ] : [
                    <Typography key="err_message" mt={2}>
                        {error.message}
                    </Typography>
                ]
            )}
            {resetError ? (
                <Box mt={1}>
                    <Button onClick={resetError}>{t("Fehler zurücksetzen")}</Button>
                </Box>
            ) : null}
        </Container>
    );
}
